/* eslint-disable import/prefer-default-export */
export const UPDATE_USER_NAME = '更新用户名'

export const UPDATE_DIALOG_SHOW = 'UPDATE_DIALOG_SHOW'



// WEBPACK FOOTER //
// ./src/vuex/modules/users/mutation-types.js